import { shell } from '../app';
import { DRAFTS_CHANGED } from '../data/drafts';
import { onSyncStatus } from '../data/sync';
import { row, section } from '../ui/components';
import { h, span } from '../ui/dom';
import { forgetDraftCount, pendingDrafts } from '../ui/sidebarData';
import type { View } from '../ui/router';

export const MORE_LINKS = [
  ['Pipeline', '/pipeline'], ['Emails', '/emails'], ['New businesses', '/signals'],
  ['Activity', '/activity'], ['Reports', '/dashboard'], ['Watchlist', '/watchlist'],
  ['Sources', '/signals/sources'], ['Plan checks', '/import/plan-checks'],
  ['New lead', '/leads/new'], ['Message templates', '/templates'], ['Sync', '/sync'],
] as const;

export const moreView: View = ({ root }) => {
  shell.setChrome(true);
  shell.setTitle('More', { back: '#/home' });
  const badge = span('badge');
  badge.hidden = true;
  let disposed = false;
  let sequence = 0;
  root.append(h('div', { class: 'page page--more' }, section({ title: 'Explore' },
    MORE_LINKS.map(([title, path]) => row({
      title: path === '/emails' ? [title, badge] : title,
      href: `#${path}`, trailing: span('chev', '›'), class: 'row--action',
    })))));
  const refresh = async () => {
    const mine = ++sequence;
    const count = await pendingDrafts();
    if (disposed || mine !== sequence) return;
    badge.hidden = count === null;
    badge.textContent = count === null ? '' : String(count);
  };
  const changed = () => { forgetDraftCount(); void refresh(); };
  void refresh();
  window.addEventListener(DRAFTS_CHANGED, changed);
  const off = onSyncStatus(s => { if (s.state === 'idle') changed(); });
  return () => { disposed = true; off(); window.removeEventListener(DRAFTS_CHANGED, changed); };
};
